"use client";
import { jsx as a } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import { cn as s } from "./index15.js";
const o = n(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-brand-primary text-brand-primary-foreground",
        secondary: "border-transparent bg-surface-raised text-text",
        destructive: "border-transparent bg-feedback-error text-text-inverse",
        success: "border-transparent bg-feedback-success text-text-inverse",
        warning: "border-transparent bg-feedback-warning text-text-inverse",
        outline: "border-border text-text"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function c({ className: e, variant: r, ...t }) {
  return /* @__PURE__ */ a("div", { className: s(o({ variant: r }), e), ...t });
}
export {
  c as Badge,
  o as badgeVariants
};
//# sourceMappingURL=index5.js.map
